import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Dashboard from '../../../Dashboard/index';

export default () => (
  <Switch>
    <Route exact path="/dashboard" component={Dashboard} />
  </Switch>
);
